import { render, staticRenderFns } from "./ElementsPicker.vue?vue&type=template&id=274d2340"
import script from "./ElementsPicker.vue?vue&type=script&lang=js"
export * from "./ElementsPicker.vue?vue&type=script&lang=js"
import style0 from "./ElementsPicker.vue?vue&type=style&index=0&id=274d2340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports